<template>
    <div>
        <div class="row col-md-12 mt-4">
            <b-container fluid>
                <div class="card card-siak">
                    <KTCodePreview>
                        <template v-slot:preview>
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="title">
                                    <h1>Master Penilaian - Edit Standar Nilai Renang</h1>
                                </div>
                            </div>

                            <AspekCard :age="data[0].umur_dari + ' - ' + data[0].umur_sampai"
                                :jenisKelamin="data[0].jenis_kelamin"></AspekCard>

                            <div class="mt-6">
                                <b-card-text>
                                    <b-container fluid>
                                        <b-row style="text-align: center; background-color: #3751E4;color: #ffffff;">
                                            <b-col md="4">Rentang Dari (Meter)</b-col>
                                            <b-col md="4">Rentang Sampai (Meter)</b-col>
                                            <b-col md="4">Score</b-col>
                                        </b-row>
                                    </b-container>

                                </b-card-text>

                                <b-card-text>
                                    <b-form class="form" @submit.stop.prevent="onSubmit">
                                        <b-container fluid>
                                            <b-row v-for="(datas, index) in data" :key="index">
                                                <b-col md="4">
                                                    <b-form-input class="form-control form-control-solid h-auto text-center"
                                                        type="text" id="example-input-2" name="example-input-2"
                                                        v-model="datas.param_dari" aria-describedby="input-2-live-feedback"
                                                        style="background: #FFFFFF; border: 1px solid #D3D3D3; border-radius: 10px;"></b-form-input></b-col>
                                                <b-col md="4">
                                                    <b-form-input class="form-control form-control-solid h-auto text-center"
                                                        type="text" id="example-input-2" name="example-input-2"
                                                        v-model="datas.param_sampai"
                                                        aria-describedby="input-2-live-feedback"
                                                        style="background: #FFFFFF; border: 1px solid #D3D3D3; border-radius: 10px;"></b-form-input></b-col>
                                                <b-col md="4">
                                                    <b-form-input class="form-control form-control-solid h-auto text-center"
                                                        type="text" id="example-input-3" name="example-input-3"
                                                        v-model="datas.nilai" aria-describedby="input-2-live-feedback"
                                                        style="background: #FFFFFF; border: 1px solid #D3D3D3; border-radius: 10px;"></b-form-input></b-col>
                                            </b-row>
                                        </b-container>
                                        <b-button type="submit" variant="primary"
                                            class="mt-2 ml-2 float-right">simpan</b-button>
                                    </b-form>
                                    <b-button type="submit" variant="outline-danger" class="mt-2 mr-2 float-right"
                                        @click="changeurl()">batal</b-button>
                                </b-card-text>
                            </div>
                        </template>
                    </KTCodePreview>
                </div>
            </b-container>
        </div>
    </div>
</template>
  
<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
import AspekCard from "@/view/content/components/card/AspekJasmaniCard.vue";

export default {
    data() {
        return {
            mainProps: { blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' },
            data: [],
            keys: this.$route.params.key,
            code4: {
                search: "",
                headers: [
                    { text: "Jumlah", value: "jumlah" },
                    { text: "Nilai", value: "nilai" }
                ],
                desserts: []
            },
        };
    },
    components: {
        KTCodePreview,
        AspekCard
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Master" },
            { title: "Master Penilaian" },
            { title: "Master Aspek Jasmani" },
            { title: "Standar Nilai Renang" },
            { title: "Edit" }
        ]);
        this.getData();
    },
    methods: {
        changeurl() {
            this.$router.push({ params: { key: this.keys }, name: 'renang' });
        },
        async getData() {
            const result = await axios.get(`master/physic/standard/6/${this.keys}`)

            this.data = result.data.data;
        },
        async onSubmit() {
            this.data.map(async (e, index) => {
                await axios.put(`master/physic/standard/saveupdate/${this.data[index].key}`, this.data[index])
                if (index < this.data.length) {
                    this.$swal('Success Edit Data');
                    this.changeurl()
                }
            })
        }
    },
};
</script>
